// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 対話履歴一覧のスタイル */
.conversation-history-container {
    padding: 20px;
    max-width: 900px;
    margin: 0 auto;
    background: #ffffff;
    background-color: rgba(255, 255, 255, 1); /* 完全に不透明 */
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    max-height: 70vh;
    overflow-y: auto;
    position: relative;
    z-index: 1;
}

.conversation-history-header {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
}

.conversation-history-title {
    font-size: 1.8rem;
    color: #333;
    margin-bottom: 8px;
    font-weight: 600;
}

.conversation-history-subtitle {
    color: #666;
    font-size: 1rem;
}

/* コントロール部分 */
.conversation-controls {
    margin-bottom: 20px;
}

.search-section {
    margin-bottom: 15px;
}

.search-input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.3s ease;
}

.search-input:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.filter-section {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
}

.filter-button {
    padding: 8px 16px;
    background: #f8f9fa;
    border: 2px solid #e9ecef;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    font-weight: 500;
}

.filter-button.active,
.filter-button:hover {
    background: #667eea;
    color: white;
    border-color: #667eea;
}

/* 会話リスト */
.conversation-list {
    max-height: 50vh;
    overflow-y: auto;
}

.conversation-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #f1f3f4;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 8px;
    margin-bottom: 8px;
}

.conversation-item:hover {
    background: #f8f9fa;
    transform: translateX(4px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.conversation-main {
    flex: 1;
    min-width: 0;
}

.conversation-title-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 5px;
}

.conversation-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
}

.audio-indicator {
    color: #28a745;
    font-size: 1rem;
}

.conversation-meta {
    color: #666;
    font-size: 0.85rem;
    margin-bottom: 5px;
}

.conversation-preview {
    color: #888;
    font-size: 0.9rem;
    max-width: 500px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.conversation-stats {
    text-align: right;
    color: #999;
    font-size: 0.8rem;
    flex-shrink: 0;
    margin-left: 16px;
}

.message-count {
    background: #667eea;
    color: white;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.75rem;
    margin-bottom: 4px;
    display: inline-block;
}

.last-updated {
    white-space: nowrap;
}

/* 状態表示 */
.loading-state,
.error-state,
.empty-state {
    text-align: center;
    padding: 40px 20px;
}

.loading-icon,
.error-icon,
.empty-icon {
    font-size: 3rem;
    margin-bottom: 16px;
    display: block;
}

.loading-state {
    color: #666;
}

.error-state {
    color: #dc3545;
}

.error-state h3 {
    margin-bottom: 8px;
    color: #333;
}

.retry-button {
    background: #667eea;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    margin-top: 16px;
    transition: background 0.3s ease;
}

.retry-button:hover {
    background: #5a6fd8;
}

.empty-state {
    color: #999;
}

.empty-state h3 {
    margin-bottom: 8px;
    color: #666;
}

/* 対話詳細 */
.conversation-detail {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.detail-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 2px solid #f0f0f0;
}

.back-button {
    background: #f8f9fa;
    border: 2px solid #e9ecef;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    white-space: nowrap;
}

.back-button:hover {
    background: #e9ecef;
    border-color: #dee2e6;
}

.detail-title h2 {
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 8px;
}

.detail-meta {
    display: flex;
    gap: 16px;
    color: #666;
    font-size: 0.9rem;
    flex-wrap: wrap;
}

.detail-controls {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    justify-content: center;
    flex-wrap: wrap;
}

.messages-container {
    max-height: 50vh;
    overflow-y: auto;
    padding-right: 8px;
}

/* メッセージスタイル */
.message {
    margin-bottom: 16px;
    padding: 12px 16px;
    border-radius: 12px;
    max-width: 75%;
    word-wrap: break-word;
    position: relative;
}

.message.user {
    background: #e3f2fd;
    border: 1px solid #bbdefb;
    margin-left: auto;
    border-bottom-right-radius: 4px;
}

.message.ai {
    background: #f3e5f5;
    border: 1px solid #e1bee7;
    margin-right: auto;
    border-bottom-left-radius: 4px;
}

.message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.message-sender {
    font-weight: 600;
    font-size: 0.9rem;
}

.message.user .message-sender {
    color: #1976d2;
}

.message.ai .message-sender {
    color: #7b1fa2;
}

.message-time {
    font-size: 0.75rem;
    color: #666;
}

.message-content {
    line-height: 1.5;
    color: #333;
    margin-bottom: 8px;
}

.message-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.action-badge {
    padding: 2px 6px;
    border-radius: 10px;
    font-size: 0.7rem;
    font-weight: 500;
    color: white;
}

.action-badge.text {
    background-color: #0066cc;
}

.action-badge.nod {
    background-color: #28a745;
}

.action-badge.store {
    background-color: #ffc107;
    color: #333;
}

.action-badge.other {
    background-color: #6c757d;
}

/* オーディオプレイヤー */
.audio-player {
    background: rgba(102, 126, 234, 0.1);
    border: 1px solid #667eea;
    border-radius: 8px;
    padding: 8px 12px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.audio-play-button {
    background: #667eea;
    color: white;
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 12px;
}

.audio-play-button:hover {
    background: #5a6fd8;
    transform: scale(1.05);
}

.audio-info {
    flex: 1;
    font-size: 0.8rem;
    color: #666;
}

/* レスポンシブデザイン */
@media (max-width: 768px) {
    .conversation-history-container {
        padding: 15px;
        margin: 10px;
        border-radius: 8px;
    }

    .conversation-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .conversation-stats {
        text-align: left;
        margin-left: 0;
    }

    .message {
        max-width: 90%;
    }

    .detail-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .detail-meta {
        justify-content: flex-start;
    }

    .filter-section,
    .detail-controls {
        justify-content: flex-start;
    }
}`, "",{"version":3,"sources":["webpack://./react/features/conversation-history/components/web/ConversationHistoryList.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,wCAAwC,EAAE,WAAW;IACrD,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,aAAa;AACb;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA,UAAU;AACV;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,SAAS;AACT;;;IAGI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;;IAGI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA,SAAS;AACT;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,WAAW;AACf;;AAEA,eAAe;AACf;IACI;QACI,aAAa;QACb,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,2BAA2B;IAC/B;AACJ","sourcesContent":["/* 対話履歴一覧のスタイル */\n.conversation-history-container {\n    padding: 20px;\n    max-width: 900px;\n    margin: 0 auto;\n    background: #ffffff;\n    background-color: rgba(255, 255, 255, 1); /* 完全に不透明 */\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    max-height: 70vh;\n    overflow-y: auto;\n    position: relative;\n    z-index: 1;\n}\n\n.conversation-history-header {\n    text-align: center;\n    margin-bottom: 30px;\n    padding-bottom: 20px;\n    border-bottom: 2px solid #f0f0f0;\n}\n\n.conversation-history-title {\n    font-size: 1.8rem;\n    color: #333;\n    margin-bottom: 8px;\n    font-weight: 600;\n}\n\n.conversation-history-subtitle {\n    color: #666;\n    font-size: 1rem;\n}\n\n/* コントロール部分 */\n.conversation-controls {\n    margin-bottom: 20px;\n}\n\n.search-section {\n    margin-bottom: 15px;\n}\n\n.search-input {\n    width: 100%;\n    padding: 12px 16px;\n    border: 2px solid #e9ecef;\n    border-radius: 8px;\n    font-size: 16px;\n    transition: border-color 0.3s ease;\n}\n\n.search-input:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.filter-section {\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.filter-button {\n    padding: 8px 16px;\n    background: #f8f9fa;\n    border: 2px solid #e9ecef;\n    border-radius: 20px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.filter-button.active,\n.filter-button:hover {\n    background: #667eea;\n    color: white;\n    border-color: #667eea;\n}\n\n/* 会話リスト */\n.conversation-list {\n    max-height: 50vh;\n    overflow-y: auto;\n}\n\n.conversation-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px;\n    border-bottom: 1px solid #f1f3f4;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border-radius: 8px;\n    margin-bottom: 8px;\n}\n\n.conversation-item:hover {\n    background: #f8f9fa;\n    transform: translateX(4px);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.conversation-main {\n    flex: 1;\n    min-width: 0;\n}\n\n.conversation-title-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 5px;\n}\n\n.conversation-title {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #333;\n}\n\n.audio-indicator {\n    color: #28a745;\n    font-size: 1rem;\n}\n\n.conversation-meta {\n    color: #666;\n    font-size: 0.85rem;\n    margin-bottom: 5px;\n}\n\n.conversation-preview {\n    color: #888;\n    font-size: 0.9rem;\n    max-width: 500px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.conversation-stats {\n    text-align: right;\n    color: #999;\n    font-size: 0.8rem;\n    flex-shrink: 0;\n    margin-left: 16px;\n}\n\n.message-count {\n    background: #667eea;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 0.75rem;\n    margin-bottom: 4px;\n    display: inline-block;\n}\n\n.last-updated {\n    white-space: nowrap;\n}\n\n/* 状態表示 */\n.loading-state,\n.error-state,\n.empty-state {\n    text-align: center;\n    padding: 40px 20px;\n}\n\n.loading-icon,\n.error-icon,\n.empty-icon {\n    font-size: 3rem;\n    margin-bottom: 16px;\n    display: block;\n}\n\n.loading-state {\n    color: #666;\n}\n\n.error-state {\n    color: #dc3545;\n}\n\n.error-state h3 {\n    margin-bottom: 8px;\n    color: #333;\n}\n\n.retry-button {\n    background: #667eea;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 14px;\n    margin-top: 16px;\n    transition: background 0.3s ease;\n}\n\n.retry-button:hover {\n    background: #5a6fd8;\n}\n\n.empty-state {\n    color: #999;\n}\n\n.empty-state h3 {\n    margin-bottom: 8px;\n    color: #666;\n}\n\n/* 対話詳細 */\n.conversation-detail {\n    padding: 20px;\n    max-height: 70vh;\n    overflow-y: auto;\n}\n\n.detail-header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 20px;\n    padding-bottom: 16px;\n    border-bottom: 2px solid #f0f0f0;\n}\n\n.back-button {\n    background: #f8f9fa;\n    border: 2px solid #e9ecef;\n    padding: 8px 16px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: 14px;\n    white-space: nowrap;\n}\n\n.back-button:hover {\n    background: #e9ecef;\n    border-color: #dee2e6;\n}\n\n.detail-title h2 {\n    font-size: 1.5rem;\n    color: #333;\n    margin-bottom: 8px;\n}\n\n.detail-meta {\n    display: flex;\n    gap: 16px;\n    color: #666;\n    font-size: 0.9rem;\n    flex-wrap: wrap;\n}\n\n.detail-controls {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.messages-container {\n    max-height: 50vh;\n    overflow-y: auto;\n    padding-right: 8px;\n}\n\n/* メッセージスタイル */\n.message {\n    margin-bottom: 16px;\n    padding: 12px 16px;\n    border-radius: 12px;\n    max-width: 75%;\n    word-wrap: break-word;\n    position: relative;\n}\n\n.message.user {\n    background: #e3f2fd;\n    border: 1px solid #bbdefb;\n    margin-left: auto;\n    border-bottom-right-radius: 4px;\n}\n\n.message.ai {\n    background: #f3e5f5;\n    border: 1px solid #e1bee7;\n    margin-right: auto;\n    border-bottom-left-radius: 4px;\n}\n\n.message-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.message-sender {\n    font-weight: 600;\n    font-size: 0.9rem;\n}\n\n.message.user .message-sender {\n    color: #1976d2;\n}\n\n.message.ai .message-sender {\n    color: #7b1fa2;\n}\n\n.message-time {\n    font-size: 0.75rem;\n    color: #666;\n}\n\n.message-content {\n    line-height: 1.5;\n    color: #333;\n    margin-bottom: 8px;\n}\n\n.message-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.action-badge {\n    padding: 2px 6px;\n    border-radius: 10px;\n    font-size: 0.7rem;\n    font-weight: 500;\n    color: white;\n}\n\n.action-badge.text {\n    background-color: #0066cc;\n}\n\n.action-badge.nod {\n    background-color: #28a745;\n}\n\n.action-badge.store {\n    background-color: #ffc107;\n    color: #333;\n}\n\n.action-badge.other {\n    background-color: #6c757d;\n}\n\n/* オーディオプレイヤー */\n.audio-player {\n    background: rgba(102, 126, 234, 0.1);\n    border: 1px solid #667eea;\n    border-radius: 8px;\n    padding: 8px 12px;\n    margin-top: 8px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.audio-play-button {\n    background: #667eea;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: 12px;\n}\n\n.audio-play-button:hover {\n    background: #5a6fd8;\n    transform: scale(1.05);\n}\n\n.audio-info {\n    flex: 1;\n    font-size: 0.8rem;\n    color: #666;\n}\n\n/* レスポンシブデザイン */\n@media (max-width: 768px) {\n    .conversation-history-container {\n        padding: 15px;\n        margin: 10px;\n        border-radius: 8px;\n    }\n\n    .conversation-item {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n    }\n\n    .conversation-stats {\n        text-align: left;\n        margin-left: 0;\n    }\n\n    .message {\n        max-width: 90%;\n    }\n\n    .detail-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n    }\n\n    .detail-meta {\n        justify-content: flex-start;\n    }\n\n    .filter-section,\n    .detail-controls {\n        justify-content: flex-start;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
